import { getCurrentLocale } from 'APP_ROOT/localization';
import {buildSettings} from 'APP_ROOT/data/events';
import {getChannelBrandingFeatures, getChannelBuildFeatures} from '../data/channels'

// StageSub(stitution) is what we will sub in for the {stage.} placeholder in the api url
// IT MUST END IN '.' IF IT ISN'T BLANK
// Warning: It's not always a match for stage (e.g. prod stage substitution is
// blank)
const HostToStageSubMapping = {
    'app.test.klashwerks.com': 'test.',
    'app.dev.klashwerks.com': 'dev.',
    'app.qa.klashwerks.com': 'qa.',
    'app.beta3.klashwerks.com': 'beta3.',
    'app.klashwerks.com': 'beta3.',
    'app.raven.is': '',
    'localhost': 'test.'
}

const HostToChannelMapping = {
    'groundtrack.ravenconnected.com': { channelCode: 'GROUNDTRAC', channelBrandingBaseUrl: '/channels/groundtrack' },
    'beta-groundtrack.ravenconnected.com': { channelCode: 'GROUNDTRAC', channelBrandingBaseUrl: '/channels/groundtrack' },
    'localhost': null
}

export default class BuildSettings {

    static buildId = process.env.REACT_APP_VERSION;
    static billingEnabled = true;
    // static billingEnabled = false;

    static cloud = process.env.REACT_APP_CLOUD;

    static isDev = function () {

        if (window.location.href.indexOf('localhost') >= 0 ||
            window.location.href.indexOf('192.168') >= 0) {
            return true
        } else {
            return false
        }
    }

    static isMobilePage = function () {

        return window.location.pathname.contains('/mobile');
    }

    static environment = function () {

        var env = 'prod';
        if (this.isDev()) env = 'test';
        if (window.location.href.indexOf('test.klashwerks.com') >= 0) env = 'test';
        if (window.location.href.indexOf('dev.klashwerks.com') >= 0) env = 'dev';
        if (window.location.href.indexOf('qa.klashwerks.com') >= 0) env = 'qa';
        if (window.location.href.indexOf('beta3.klashwerks.com') >= 0) env = 'beta3';
        if (window.location.href.indexOf('app.klashwerks.com') >= 0) env = 'beta3';
        if (window.location.href.indexOf('beta.raven.is') >= 0) env = 'beta3';
        if (window.location.href.indexOf('beta.ravenconnected.com') >= 0) env = 'beta3';
        if (window.location.href.indexOf('app-staging-') >= 0) env = window.location.href.match(/app-staging-([\w-]+)/)[1];
        if (window.location.href.indexOf('app.raven.is') >= 0) env = 'prod';
        if (window.location.href.indexOf('preview') >= 0) env = 'prod'; // preview-v2. and production-preview.ravenconnected.com 

                // return 'test';
        // return 'dev';
        // return 'qa';
        // return 'beta3';
        // return 'prod';
        return env;
    }

    static kloudApiUrlForHost = (webAppHost, apiPath) => {
        let stagesub = HostToStageSubMapping[webAppHost] || '';
        if (stagesub === 'prod') stagesub = '';
        const base = process.env.REACT_APP_KLOUD_API_BASE_URL.replace('{stage.}', stagesub);
        return `${base}${apiPath}`;
    }

    static kloudApiUrl = (path) => {
        const host = window.location.host.replace(/:.*$/, '');
        return BuildSettings.kloudApiUrlForHost(host, path);
    }

    static tripSharingQueryUrl = function () {
        return BuildSettings.kloudApiUrl('/raven/trip-query');
    }

    static tripSharingPreviewUrl = function (tripUuid) {
        return BuildSettings.kloudApiUrl(`/raven/trip-preview-request?tripUuid=${tripUuid}`);
    }

    static tripShareMqttHost = function () {
        return process.env.REACT_APP_TRIP_SHARE_MQTT_HOST
    }

    static invitationQueryUrl = function () {
        return BuildSettings.kloudApiUrl('/raven/invitation-details');
    }

    static isProductionBuild = function () {
        var stage = BuildSettings.environment();

        if (stage === 'prod' ||
            stage === 'beta3' ||
            stage === 'qa')
            return true;
        else return false;
    }

    static helpUrl = path => {
        const stage = BuildSettings.environment();
        let urlBase;
        switch(stage) {
            case 'beta3':
            case 'qa':
            case 'test':
            case 'dev':
                urlBase = 'https://docs.klashwerks.com';
                break;
            default:
                urlBase = 'https://docs.raven.is';
        }
        return `${urlBase}/${getCurrentLocale()}${path}`;
    }

    static applyBuildFeatures(features) {

        // start with build features
        let buildFeatures = {};

        // Check if the feature set has a matching channel config with buildFeatures
        const channelBuildFeatures = getChannelBuildFeatures(process.env.REACT_APP_FEATURE_SET);

        if (channelBuildFeatures) {
            buildFeatures = channelBuildFeatures;
        } else {
            switch(process.env.REACT_APP_FEATURE_SET) {
                case 'showcase':
                    buildFeatures = {
                        integrations: true,
                        showcase_raven_selector: true,
                        showcase_sample_videos: true,
                        showcase_fake_events: false,
                        showcase_preferences: true,
                        showcase_security_alerts: true,
                        showcase_asset_trackers: true,
                        language_selection: false,
                        global_settings: {
                            section_available: false,
                            audio: true, // default is true, but overridden by section_available
                            daily_reports: true,
                            driver_alerts: {
                                section_available: true,
                                audio_notifications: true // default is true, but overridden by section_available
                            },
                            gestures: true, // default, but overridden by section_available
                            video_quality: false,
                            wifi_hotspot: true, // default, but overridden by section_available
                            events: {
                                section_available: false,
                                bad_install: false,
                                camera_obscured: false,
                                cellphone_detection: false,
                                distracted_detection: false,
                                drinking_detection: false,
                                eating_detection: false,
                                possible_impact: false,
                                potential_red_light_camera_violation: false,
                                potential_speed_camera_violation: false,
                                refueling: false,
                                smoking_detection: false,
                                speeding: false,
                                stop_sign_violation: false,
                                tailgating_detection: false,
                                tired_detection: false
                            }
                        }
                    };
                    break;
                case 'beta':
                    buildFeatures = {
                        show_billing: true, // RAV-788: new user has no ravens, but must enter billing info
                        show_raven_external_id: false,
                        integrations: true,
                        facial_recognition: true,
                        language_selection: false,
                        global_settings: {
                            section_available: true,
                            audible_alerts: true,
                            audio: true, // default is true
                            daily_reports: true,
                            driver_alerts: {
                                section_available: true,
                                audio_notifications: true // default is true, but overridden by section_available
                            },
                            gestures: true, // default
                            video_quality: true,
                            wifi_hotspot: true, // default
                            events: {
                                section_available: true,
                                aggressive_accel: true, // default is true, but overridden by section_available
                                bad_install: false,
                                //camera_obscured: true, (see isBuiltByDefault in data/events/configurations/camera_obscured.js)
                                car_bumped: true,
                                //cellphone_detection: true, (see isBuiltByDefault in data/events/configurations/cellphone_detection.js)
                                //distracted_detection: true, (see isBuiltByDefault in data/events/configurations/distracted_detection.js)
                                //drinking_detection: true, (see isBuiltByDefault in data/events/configurations/drinking_detection.js)
                                //eating_detection: true, (see isBuiltByDefault in data/events/configurations/eating_detection.js)
                                hard_braking: true, // default is true, but overridden by section_available
                                hard_cornering: true, // default is true, but overridden by section_available
                                idling: true, // default is true, but overridden by section_available
                                possible_impact: true, // default is true, but overridden by section_available
                                //potential_red_light_camera_violation: true, (see isBuiltByDefault in data/events/configurations/potential_red_light_camera_violation.js)
                                //potential_speed_camera_violation: true, (see isBuiltByDefault in data/events/configurations/potential_speed_camera_violation.js)
                                refueling: true,
                                //smoking_detection: true, (see isBuiltByDefault in data/events/configurations/smoking_detection.js)
                                speeding: true, // default is true, but overridden by section_available
                                //stop_sign_violation: true, (see isBuiltByDefault in data/events/configurations/stop_sign_violation.js)
                                tailgating_detection: true,
                                //tired_detection: true (see isBuiltByDefault in data/events/configurations/tired_detection.js)
                            }
                        }
                    };
                    break;
                default:
                    buildFeatures = {
                        show_billing: true, // RAV-788: new user has no ravens, but must enter billing info
                        show_raven_external_id: false,
                        integrations: true,
                        facial_recognition: true,
                        language_selection: false,
                        global_settings: {
                            section_available: true,
                            audible_alerts: true,
                            audio: true, // default is true
                            daily_reports: true,
                            driver_alerts: {
                                section_available: true,
                                audio_notifications: true // default is true, but overridden by section_available
                            },
                            gestures: true, // default
                            video_quality: true,
                            wifi_hotspot: true, // default
                            events: {
                                section_available: true,
                                aggressive_accel: true, // default is true, but overridden by section_available
                                bad_install: false,
                                //camera_obscured: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/camera_obscured.js)
                                car_bumped: true,
                                //cellphone_detection: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/cellphone_detection.js)
                                //distracted_detection: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/distracted_detection.js)
                                //drinking_detection: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/drinking_detection.js)
                                //eating_detection: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/eating_detection.js)
                                hard_braking: true, // default is true, but overridden by section_available
                                hard_cornering: true, // default is true, but overridden by section_available
                                idling: true, // default is true, but overridden by section_available
                                possible_impact: true, // default is true, but overridden by section_available
                                //potential_red_light_camera_violation: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/potential_red_light_camera_violation.js)
                                //potential_speed_camera_violation: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/potential_speed_camera_violation.js)
                                refueling: true,
                                //smoking_detection: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/smoking_detection.js)
                                speeding: true, // default is true, but overridden by section_available
                                //stop_sign_violation: true, (see isBuiltEnvironmentOverride.prod in data/events/configurations/stop_sign_violation.js)
                                tailgating_detection: true,
                                //tired_detection: true (see isBuiltEnvironmentOverride.prod in data/events/configurations/tired_detection.js)
                            }
                        }
                    };
                    break;
            }
        }

        buildFeatures.debug = process.env.NODE_ENV === 'development';

        buildFeatures.global_settings.events = {
            ...buildFeatures.global_settings.events,
            ...buildSettings(process.env.REACT_APP_FEATURE_SET)
        };        

        // add stage features
        let stageFeatures;
        switch(BuildSettings.environment()) {
            case 'dev':
                stageFeatures = {
                    debug: true
                }
                break;
            case 'beta3':
            case 'qa':
            case 'test':
            default:
                stageFeatures = {
                };
        }

        const channelBrandingFeatures = BuildSettings.applyChannelBrandingFeatures({}, process.env.REACT_APP_FEATURE_SET);

        return Object.assign(features, buildFeatures, stageFeatures, channelBrandingFeatures);
    }

    static applyChannelBrandingFeatures (features, channelCode) {
        const channelBrandingFeatures = getChannelBrandingFeatures(channelCode);
        return Object.assign(features, channelBrandingFeatures);
    }

    static getChannelFromHostname = () => {
        const host = window.location.hostname;
        return HostToChannelMapping[host] || null;
    }
}

window.BuildSettings = BuildSettings;
